import React from "react";
import ToastAlertContext from "../context/ToastAlertContext";

export default function useToastAlert() {
  return React.useContext(ToastAlertContext);
}
